"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _shortid = _interopRequireDefault(require("shortid"));
var _createClassName = _interopRequireDefault(require("../../utils/createClassName"));
var _Alert = _interopRequireDefault(require("./Alert"));
var _AlertContainer2 = require("./styled/AlertContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/no-unused-class-component-methods */
var defaultProps = {
  className: '',
  stack: 'bottom'
};
var AlertContainer = /*#__PURE__*/function (_Component) {
  function AlertContainer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, AlertContainer);
    _this = _callSuper(this, AlertContainer, [props]);
    (0, _defineProperty2.default)(_this, "error", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var settings = {
        showIcon: true,
        icon: /*#__PURE__*/_react.default.createElement(_AlertContainer2.CautionWarningIconStyled, {
          type: "error"
        })
      };
      return _this.show(_objectSpread(_objectSpread(_objectSpread({}, settings), options), {}, {
        type: 'error'
      }));
    });
    (0, _defineProperty2.default)(_this, "info", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var settings = {
        showIcon: true,
        icon: /*#__PURE__*/_react.default.createElement(_AlertContainer2.InfoIconStyled, null)
      };
      return _this.show(_objectSpread(_objectSpread(_objectSpread({}, settings), options), {}, {
        type: 'info'
      }));
    });
    (0, _defineProperty2.default)(_this, "success", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var icon;
      switch (options.type) {
        case 'warning':
          icon = /*#__PURE__*/_react.default.createElement(_AlertContainer2.CautionWarningIconStyled, {
            type: "success"
          });
          break;
        case 'mail':
          icon = /*#__PURE__*/_react.default.createElement(_AlertContainer2.MailCircleIconStyled, null);
          break;
        default:
          icon = /*#__PURE__*/_react.default.createElement(_AlertContainer2.SuccessIconStyled, null);
      }
      var settings = {
        showIcon: true,
        icon: icon
      };
      return _this.show(_objectSpread(_objectSpread(_objectSpread({}, settings), options), {}, {
        type: 'success'
      }));
    });
    (0, _defineProperty2.default)(_this, "show", function (options) {
      var stack = _this.props.stack;
      var alerts = _this.state.alerts;
      if (!options || !options.message) {
        return false;
      }
      var delay = options.delay;
      var id = _shortid.default.generate();
      var settings = _objectSpread(_objectSpread({}, options), {}, {
        id: id,
        removeAlert: _this.removeAlert
      });
      if (stack === 'top') {
        alerts.unshift(settings);
      } else {
        alerts.push(settings);
      }
      var applyUpdate = function applyUpdate() {
        return _this.setState({
          alerts: alerts
        });
      };
      if (delay) {
        setTimeout(applyUpdate, delay);
      } else {
        applyUpdate();
      }
      return id;
    });
    (0, _defineProperty2.default)(_this, "removeAlert", function (alertId) {
      var alerts = _this.state.alerts;
      _this.setState({
        alerts: alerts.filter(function (alert) {
          return alert.id !== alertId;
        })
      });
    });
    (0, _defineProperty2.default)(_this, "removeAllAlerts", function () {
      _this.setState({
        alerts: []
      });
    });
    _this.state = {
      alerts: []
    };
    return _this;
  }
  (0, _inherits2.default)(AlertContainer, _Component);
  return (0, _createClass2.default)(AlertContainer, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      var alerts = this.state.alerts;
      return /*#__PURE__*/_react.default.createElement(_AlertContainer2.ContainerStyled, {
        className: (0, _createClassName.default)('AlertContainer', className || '', '')
      }, alerts.map(function (alert) {
        return /*#__PURE__*/_react.default.createElement(_Alert.default, (0, _extends2.default)({
          key: alert.id
        }, alert));
      }));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(AlertContainer, "defaultProps", defaultProps);
var _default = exports.default = AlertContainer;